import PubSub from "underpub-js";

var HighlightCallout = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-HighlightCallout',
	};

	$.extend(true, this.options, options);

};

HighlightCallout.prototype.init = function() {

	var self = this;

};

export default HighlightCallout;
